<template>
  <div class="col-xs-12 p-0">
    <input
      class="form-control search-box"
      type="text" v-model.trim="searchKeyword"
      :placeholder="$t('search')"
      @keydown.enter.prevent="emitGetList"
      @keyup="fetchAccountList"
     />
    <div>
      <!-- <img v-if="searchKeyword" @click="resetSearchKeyword"
        src="/static/images/icons/danger_close_icon.svg"
        alt
        class="cursor-pointer search-reset"
      /> -->
      <span @click="emitGetList()" class="search-icon cursor-pointer" :class="{ 'events-none': disableSearch }">
        <img src="/static/images/icons/Search.svg" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    disableSearch: {
      required: false,
    },
    fetchAccountsBasedOnSearch: {
      required: false,
      default: false,
    },
    complianceTracker: {
      required: false,
    },
    teamBorder: {
      required: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    searchKeyword: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    resetSearchKeyword() {
      this.searchKeyword = '';
      this.emitGetList();
    },

    fetchAccountList() {
      if (this.fetchAccountsBasedOnSearch) {
        this.$emit('fetchAccount');
      }
    },

    emitGetList() {
      this.$emit('getList');
    },
  },
};
</script>

<style scoped>
.form-control::placeholder {
  color: rgba(0, 0, 0, 0.5);
}
.search-reset {
  top: 7px;
  right: 50px;
  height: 22px;
  width: 22px;
}

.search-box {
  padding-left: 16px;
  color: #333333;
  font-weight: 300;
  padding-right: 84px;
  padding-left: 51px;
  font-size: 18px;
  border: 0.5px solid #000000;
}

.form-control:focus {
  border-color: #000000;
}

.search-box:hover {
  box-shadow: none;
}

.search-icon {
  top: 5px;
  position: absolute;
  left: 5px;
  padding-left: 10px;
}

.form-control {
  height: 44px;
}

.events-none {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
